import type { ReactNode } from "react";
import { BottomNav } from "./BottomNav";

// A page's frame: the main landmark, plus the bottom tab bar and the padding that keeps
// content from sliding underneath it.
export function Screen({ children, nav = true }: { children: ReactNode; nav?: boolean }) {
  return (
    <>
      <main className={nav ? "screen screen-with-nav" : "screen"}>{children}</main>
      {nav && <BottomNav />}
    </>
  );
}
